var localStorageMock = function () {
  var store = {};
  return {
    getItem: function getItem(key) {
      return store[key] || null;
    },
    setItem: function setItem(key, value) {
      store[key] = value.toString();
    },
    removeItem: function removeItem(key) {
      delete store[key];
    },
    clear: function clear() {
      store = {};
    }
  };
}();

// let enhancedLocalStorage: Storage = {} as Storage;
// if (typeof window !== 'undefined') {
//   enhancedLocalStorage = window.localStorage;
// } else {
//   import('node-localstorage').then(({ LocalStorage }) => {
//     enhancedLocalStorage = new LocalStorage('./scratch');
//   });
// }
// export { enhancedLocalStorage };

var enhancedLocalStorage;
if (typeof window !== 'undefined') {
  enhancedLocalStorage = window.localStorage;
} else {
  enhancedLocalStorage = localStorageMock;
}
export { enhancedLocalStorage, localStorageMock };